import { render, staticRenderFns } from "./UserFeature.vue?vue&type=template&id=3f2d2808&scoped=true&"
import script from "./UserFeature.vue?vue&type=script&lang=js&"
export * from "./UserFeature.vue?vue&type=script&lang=js&"
import style0 from "./UserFeature.vue?vue&type=style&index=0&id=3f2d2808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d2808",
  null
  
)

export default component.exports